// extracted by mini-css-extract-plugin
export var centerText = "_c5-8";
export var container = "_c5-0";
export var doughnutContainer = "_c5-7";
export var legend = "_c5-a";
export var legendItemColorDisplay = "_c5-b";
export var legendItemLabel = "_c5-d";
export var legendItemValue = "_c5-c";
export var lg = "_c5-5";
export var maxWidth = "_c5-9";
export var md = "_c5-4";
export var responsive = "_c5-6";
export var sm = "_c5-3";
export var xs = "_c5-2";
export var xxs = "_c5-1";